import React, { Component, createRef } from 'react'
import ContentEditable from 'react-contenteditable'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { endTextEdit } from '../../store/cursor'
import { patchNode } from '../../controllers/treeEngine'

// We tried to convert this component to function but this.inputRef.current.focus() did not
// work with iOS devices sometimes. This might be related:
// https://stackoverflow.com/questions/18728166/programmatically-focus-on-next-input-field-in-mobile-safari
class NodeTextInputComponent extends Component {
    constructor(props) {
        super(props)
        this.inputRef = createRef()
    }

    componentDidMount() {
        this.inputRef.current.focus()

        // Move cursor to the end
        const range = document.createRange() // A range is a like the selection but invisible
        range.selectNodeContents(this.inputRef.current)
        range.collapse(false) // Collapse the range to the end

        const selection = window.getSelection()
        selection.removeAllRanges()
        selection.addRange(range)
    }

    render() {
        const { value, endTextEdit, id } = this.props

        const onPaste = (event) => {
            event.preventDefault()
            const text = event.clipboardData.getData('text/plain')
            document.execCommand('insertHTML', false, text)
        }

        const onTextBlur = () => {
            if (document.activeElement !== this.inputRef.current) {
                endTextEdit()
            }
        }

        const onTextChange = (event) => {
            const value = event.target.value.replace(/<br>$/, '')
            const body = {
                text: value
            }
            const nodeId = id

            patchNode(nodeId, body)
        }

        return (
            <ContentEditable
                html={value}
                innerRef={this.inputRef}
                onPaste={onPaste}
                onBlur={onTextBlur}
                onChange={onTextChange}
            />
        )
    }
}

const mapDispatchToProps = {
    endTextEdit
}

export const NodeTextInput = withRouter(connect(undefined, mapDispatchToProps)(NodeTextInputComponent))
